import { render } from "./comment.svg?vue&type=template&id=3d43e447?inline"
const script = {}
script.render = render

export default script